import { Component, HostListener, NgZone, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AppContext } from './shared/app-context';
import { AppConfiguration } from './core/services/app-configuration';
import { APP_CONFIGURATION_KEYS } from './shared/constants/app-configuration-keys';
import { ContentResultType } from './shared/interfaces/content-result.interface';
import { LoggerService } from './core/services/logger.service';

@Component({
  selector: 'emma-claims-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class AppComponent {
  public title = 'EMMA-Claims-UI';
  constructor(
    private readonly router: Router,
    public readonly appContext: AppContext,
    private readonly loggerService: LoggerService,
    private readonly appConfigurationService: AppConfiguration
  ) {}
  @HostListener('document:banner.navigate', ['$event'])
  public onBannerNavigate($event: Event): void {
    const customEvent = $event as CustomEvent<string>;
    this.router.navigate([customEvent.detail]);
  }

  public ngOnInit(): void {
    this.appConfigurationService
      .getAppConfiguration(APP_CONFIGURATION_KEYS.applicationInsightConnectionstring)
      .subscribe({
        next: (result: ContentResultType) => {
          this.appContext.appInsightConnectionString = result?.content;
          this.loggerService.initializeApplicationInsightsLog();
        }
      });
  }
}
